export default __webpack_public_path__ + "static/media/add-square.4ddbf8f7.svg";